export default "/images/shopping-bag.svg?1d26564602e1b9bb7b8e1a9beecb2ae0";